var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


let trigger = document.querySelector('.js-menu-trigger'),
    menu = document.querySelector('.js-menu'),
    wholeHeader = document.querySelector('.shopify-section.header-container'),
    logo = document.querySelector('.js-logo-animation');


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);


let menuParent = menu.querySelectorAll('nav > ul > li'),
    menuImages = menu.querySelectorAll('.image');

menuParent.forEach((elem, i) => {

    // Look the image up inside this item; a link without an image is skipped
    // instead of throwing (which used to kill the whole menu script).
    let image = elem.querySelector('.image');
    if (!image) return;
    let img = image.querySelector('img');

    elem.addEventListener("mouseover", mOver, false);
    elem.addEventListener("mouseout", mOut, false);

    function mOver() {
      menuParent.forEach(elem => { elem.classList.remove('active') });
      menuImages.forEach(image => { image.classList.remove('active') });
      image.classList.add('active');
      elem.classList.add('active');

      return false;
      this.classList.add("active");
    }

    function mOut() {
      // this.classList.remove("active");
      return false;
    }

    gsap.set(image, {xPercent: -50, yPercent: -50});

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const mouse = { x: pos.x, y: pos.y };
    const speed = 0.2;

    const xSet = gsap.quickSetter(image, "x", "px");
    const ySet = gsap.quickSetter(image, "y", "px");

    window.addEventListener("mousemove", e => {
      mouse.x = e.x;
      mouse.y = e.y;
    });

    gsap.ticker.add(() => {

      // adjust speed for higher refresh monitors
      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      xSet(pos.x);
      ySet(pos.y);
    });

});


// window.addEventListener('resize', function(){
//     child.forEach((elem, i) => {
//
//         if (elem.clientHeight > 0) {
//             elem.style.removeProperty('height');
//             let realHeight = child[i].offsetHeight;
//             elem.setAttribute("data-height", realHeight + "px");
//             elem.style.height = realHeight;
//         } else {
//             elem.style.removeProperty('height');
//             let realHeight = child[i].offsetHeight;
//             elem.setAttribute("data-height", realHeight + "px");
//             elem.style.height = 0;
//         }
//
//     });
// });


let menuOpen = false,
    menuBg = menu.querySelector('.js-menu-bg'),
    menuImg = menu.querySelectorAll('.js-menu-image img'),
    menuNav = menu.querySelectorAll('nav');

let menuAnim = gsap.timeline()
    .from(menuBg, 1, { scaleX: 0, transformOrigin: 'right' })
    .from(menuImg, 0.5, { opacity: 0 }, "-=0.5")
    .duration(2)
    .paused(true);

trigger.addEventListener('click', function () {

  if (trigger.classList.contains('active')) {
    trigger.querySelector('.trigger').innerHTML = '<span>m</span><span>e</span><span>n</span><span>u</span>';
  } else {
    trigger.querySelector('.trigger').innerHTML = '<span>c</span><span>l</span><span>o</span><span>s</span><span>e</span>';
  }

  menu.classList.toggle('active');
  document.body.classList.toggle('menu-open');
  trigger.classList.toggle('active');
  wholeHeader.classList.toggle('active');
  logo.classList.toggle('active');

  gsap.set(menuNav, { zIndex: 2 });

  if (menuOpen == false) {
    console.log('play');
    menuAnim.play();
    menuOpen = true;
  } else {
    console.log('reverse');
    menuAnim.reverse();
    menuOpen = false;
  }

});
